import MessageIcon from './message';

export default MessageIcon;
